
import axios from 'axios';
var API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
var WEBAPIV2_ENDPOINT = process.env.VUE_APP_WEBAPIV2_ENDPOINT;
var ConsumerAPI = process.env.VUE_APP_ConsumerAPI_ENDPOINT;
var GSAI_API = process.env.VUE_APP_GSAI_API_ENDPOINT;
var API_KEY = process.env.VUE_APP_API_KEY;
//var API_ENDPOINT = 'https://localhost:44381/';
//var API_ENDPOINT = 'https://localhost:7059/';

export default {
  GetPCConditionsAIResult(investorCond, investorName) {
    // Initialize an empty array for the request body
    const requestBody = [];

    // Loop through the investor conditions array
    for (let cond = 0; cond < investorCond.length; cond++) {
      // Create an object for each condition and push it to the requestBody array
      requestBody.push({
        InvestorCondition: investorCond[cond],
        InvestorName: investorName
      });
    }

    // Send the request using Axios
    return axios
      .post(GSAI_API + "api/Models/PostClosingConditions", requestBody, {
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY
        }
      })
      .then((response) => {
        return response.data.data; // Extract and return only the 'data' key's value
      })
      .catch((error) => {
        console.error("Error:", error.response?.data || error.message); // Log the error
        throw error; // Re-throw the error for further handling
      });
  },
  LookupAuth0UserByLoan(loanId, token) {
    return axios.get(ConsumerAPI + "api/Auth0/LookupAuth0UserByLoan?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetLoanLock(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetLoanLock?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  SubmitCopyDocsRequest(token, request) {
    return axios.post(API_ENDPOINT + "api/Attachments/SubmitCopyDocsRequest", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  CreatePrintOrder(token, request) {
    return axios.post(API_ENDPOINT + "api/EncompassDocs/CreatePrintOrder", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  OrderEncompassDocs(request, token) {
    return axios.post(API_ENDPOINT + "api/EncompassDocs/OrderEncompassDocs", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  ConditionLoan(loanId, token) {
    return axios.post(API_ENDPOINT + "api/Conditions/ConditionLoan?loanId=" + loanId, {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  UploadAttachmentAndPutInBucket(attachment, token) {
    return axios.post(API_ENDPOINT + `api/Attachments/UploadAttachmentAndPutInBucket?loanId=${attachment.loanId}`, attachment,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UploadAttachmentWithContentTypeAndPutInBucket(attachment, token) {
    return axios.post(API_ENDPOINT + `api/Attachments/UploadAttachmentWithContentTypeAndPutInBucket?loanId=${attachment.loanId}`, attachment,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  AssignAttachmentToBucket(loanId, request, token) {
    return axios.post(API_ENDPOINT + `api/Attachments/AssignAttachmentToBucket?loanId=${loanId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpdateAttachmentCurrentVersion(loanId, request, token) {
    return axios.post(API_ENDPOINT + `api/Attachments/UpdateAttachmentCurrentVersion?loanId=${loanId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  hasExclusiveLock(loanid, token) {

    return axios.get(API_ENDPOINT + "api/Loans/Getloanlock?loanId=" + loanid,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  getConditions(loanid, token) {

    return axios.get(API_ENDPOINT + "api/Conditions/GetLoanCondition?loanId=" + loanid,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  getDocuments(loanid, token) {

    return axios.get(API_ENDPOINT + "api/Documents/GetDocuments?loanId=" + loanid,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetDocumentComments(loanId, documentId, token) {
    return axios.get(API_ENDPOINT + `api/Documents/GetDocumentComments?loanId=${loanId}&documentId=${documentId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  CreateDocumentComment(loanId, documentId, request, token) {
    return axios.post(API_ENDPOINT + `api/Documents/CreateDocumentComment?loanId=${loanId}&documentId=${documentId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  getAttachments(loanid, token) {

    return axios.get(API_ENDPOINT + "api/Attachments/GetAttachments?loanId=" + loanid,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  UpdateLoanCondition(loanid, condition, token) {

    return axios.post(API_ENDPOINT + "api/Conditions/UpdateLoanCondition?loanId=" + loanid, condition,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  UpdateConditionTracking(request, token) {

    return axios.post(API_ENDPOINT + `api/Conditions/UpdateConditionTracking?loanId=${request.loanId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetConditionsToAdd(token) {
    return axios.get(API_ENDPOINT + "api/Conditions/GetConditionsToAdd",
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetConditionTemplates(token) {
    return axios.get(API_ENDPOINT + "api/Conditions/GetConditionTemplates",
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  AddCondition(loanid, bySwift, condition, token) {

    return axios.post(API_ENDPOINT + `api/Conditions/AddCondition?loanId=${loanid}&bySwift=${bySwift}`, condition,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  AddConditionAndTracking(loanid, bySwift, request, token) {

    return axios.post(API_ENDPOINT + `api/Conditions/AddConditionAndTracking?loanId=${loanid}&bySwift=${bySwift}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  AddConditions(loanid, bySwift, request, token) {
    return axios.post(API_ENDPOINT + `api/Conditions/AddConditions?loanId=${loanid}&bySwift=${bySwift}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpdateDocumentDescription(updatedDocumentDescription, token) {

    return axios.post(API_ENDPOINT + "api/Documents/UpdateDocumentDescription", updatedDocumentDescription,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  AttachDocumentCondition(loanid, conditionId, documents, token) {

    return axios.post(API_ENDPOINT + "api/Conditions/AttachDocumentCondition?loanId=" + loanid + "&conditionId=" + conditionId, documents,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  AttachDocumentConditions(loanid, documents, token) {

    return axios.post(API_ENDPOINT + "api/Conditions/AttachDocumentConditions?loanId=" + loanid, documents,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  MoveAttachmentToJunkFolder(loanid, documentid, attachment, token) {

    return axios.post(API_ENDPOINT + "api/Documents/MoveAttachmentToJunkFolder?loanId=" + loanid + "&documentId=" + documentid, attachment,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  RemoveDocumentCondition(loanid, conditionId, documents, token) {

    return axios.post(API_ENDPOINT + "api/Conditions/RemoveDocumentCondition?loanId=" + loanid + "&conditionId=" + conditionId, documents,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetAttachmentsFileBytes(attachmentsFile, token, includeNotActive = false) {

    return axios.post(API_ENDPOINT + `api/Attachments/GetAttachmentsFileBytes?includeNotActive=${includeNotActive}`, attachmentsFile,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetOriginalAttachmentsFileBytes(attachmentsFile, token, includeNotActive = false) {

    return axios.post(API_ENDPOINT + `api/Attachments/GetOriginalAttachmentsFileBytes?includeNotActive=${includeNotActive}`, attachmentsFile,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetMergedAttachmentsFileBytes(attachmentsFile, token) {

    return axios.post(API_ENDPOINT + "api/Attachments/GetMergedAttachmentsFileBytes", attachmentsFile,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetLoan(loanId, token) {

    return axios.get(API_ENDPOINT + "api/Loans/GetLoan?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetClearToCloseLetter(loanid, request, token) {
    return axios.post(API_ENDPOINT + "api/attachments/GetClearToCloseApprovalLetterAndNotification?loanId=" + loanid, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetCondlApprovalLetter(loanid, request, token) {
    return axios.post(API_ENDPOINT + "api/attachments/GetCondApprovalLetterAndNotification?loanId=" + loanid, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetSuspensLetter(loanid, request, token) {
    return axios.post(API_ENDPOINT + "api/attachments/GetSuspendedApprovalLetterAndNotification?loanId=" + loanid, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  GetFile(fileId, token) {
    return axios.get(API_ENDPOINT + "api/Blueprint/GetFile?fileId=" + fileId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpdateFile(file, token) {
    return axios.post(API_ENDPOINT + "api/Blueprint/UpdateFile", file,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetFiles(token) {
    return axios.get(API_ENDPOINT + "api/Blueprint/GetFiles",
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetBlueprintInfo(loanNumber, loanId, token) {
    return axios.get(API_ENDPOINT + "api/Blueprint/GetBlueprintInfo?loanNumber=" + loanNumber + "&loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  AddBorrower(borrower, token) {
    return axios.post(API_ENDPOINT + "api/Blueprint/AddBorrower", borrower,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpdateBorrower(borrower, token) {
    return axios.post(API_ENDPOINT + "api/Blueprint/UpdateBorrower", borrower,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  DeleteBorrower(borrower, token) {
    return axios.post(API_ENDPOINT + "api/Blueprint/DeleteBorrower", borrower,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  BulkUpdateConditionTracking(loanid, trackingPost, token) {

    return axios.post(API_ENDPOINT + "api/Conditions/BulkUpdateConditionTracking?loanId=" + loanid, trackingPost,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  UploadAttachmentToLoan(attachment, token) {

    return axios.post(API_ENDPOINT + "api/Attachments/UploadAttachmentToLoan", attachment,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },

  GetLoanNotes(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetLoanNotes?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  SubmitNote(loanNote, token) {
    return axios.post(API_ENDPOINT + "api/Loans/SubmitNote", loanNote,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetUsers(token) {
    return axios.get(API_ENDPOINT + "api/EncompassUsers/GetUsers",
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetUsersByRole(roleId, token) {
    return axios.get(API_ENDPOINT + "api/EncompassUsers/GetUsersByRole?roleId=" + roleId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetProcessors(token) {
    return axios.get(API_ENDPOINT + "api/EncompassUsers/GetProcessors",
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetMilestones(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetMilestones?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  AssignAssociateToMilestone(assignAssociateDto, token) {
    return axios.put(API_ENDPOINT + "api/Loans/AssignAssociateToMilestone", assignAssociateDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  ConditionallyApproveLoan(dispositionDto, token) {
    return axios.patch(API_ENDPOINT + `api/Loans/ConditionallyApproveLoan?loanId=${dispositionDto.loanId}`, dispositionDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetLoanFieldList(loanId, fieldIds, token) {
    return axios.post(API_ENDPOINT + "api/Loans/GetLoanFieldList?loanId=" + loanId, fieldIds,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpdateLoanFieldValues(loanId, updateLoanFieldsDto, token) {
    //return axios.post('https://localhost:44381/' + "api/Loans/UpdateLoanFieldValues?loanId=" + loanId, updateLoanFieldsDto,
    return axios.post(API_ENDPOINT + "api/Loans/UpdateLoanFieldValues?loanId=" + loanId, updateLoanFieldsDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  RefreshLoanFieldValues(loanId, refreshLoanFieldsDto, token) {
    return axios.post(API_ENDPOINT + "api/Loans/RefreshLoanFieldValues?loanId=" + loanId, refreshLoanFieldsDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  SuspendLoan(dispositionDto, token) {
    return axios.post(API_ENDPOINT + `api/Loans/SuspendLoan?loanId=${dispositionDto.loanId}`, dispositionDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  DenyLoan(dispositionDto, token) {
    return axios.post(API_ENDPOINT + "api/Loans/DenyLoan?loanId=" + dispositionDto.loanId, dispositionDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  RestructureLoan(loanId, unfinishMilestones, token) {
    return axios.post(API_ENDPOINT + "api/Loans/RestructureLoan?loanId=" + loanId, unfinishMilestones,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetOtherLiabilities(loanId, applicationId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetOtherLiabilities?loanId=" + loanId + "&applicationId=" + applicationId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetLoanVols(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetLoanVols?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetCreditXML(loanId, token) {
    return axios.patch(API_ENDPOINT + "api/Loans/GetCreditXML?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  OrderAUS(loanId, loanType, token) {
    return axios.get(API_ENDPOINT + "api/EncompassLoans/OrderAUS?id=" + loanId + '&type=' + loanType,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetApplicationVODs(loanId, applicationId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetApplicationVODs?loanId=" + loanId + '&applicationId=' + applicationId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetApplicationGiftGrants(loanId, applicationId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetApplicationGiftGrants?loanId=" + loanId + '&applicationId=' + applicationId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetApplicationOtherAssets(loanId, applicationId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetApplicationOtherAssets?loanId=" + loanId + '&applicationId=' + applicationId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetBorrowerFundsToClose(loanId, applicationId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetBorrowerFundsToClose?loanId=" + loanId + '&applicationId=' + applicationId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  ClearToCloseLoan(ctcDto, token) {
    return axios.post(API_ENDPOINT + "api/Loans/ClearToCloseLoan?loanId=" + ctcDto.loanId, ctcDto,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetAgentImageURLByEmail(email, token) {
    return axios.get(API_ENDPOINT + "api/Agents/GetAgentImageUrlByEmail?email=" + email,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetDBAExperience(domain, token) {
    return axios.get(API_ENDPOINT + "api/LoanOfficers/GetDBAExperience?domain=" + domain,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetLOProfilePhoto(email, token) {
    return axios.get(API_ENDPOINT + "api/LoanOfficers/GetLOProfilePhoto?email=" + email,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetUser(email, token) {
    return axios.get(API_ENDPOINT + "api/LoanOfficers/GetUser?email=" + email,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetLoanTeamMembers(loanId, request, token) {
    return axios.post(API_ENDPOINT + `api/Loans/GetLoanTeamMembers?loanId=${loanId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetMessagesByLoanId(loanId, token) {
    return axios.get(API_ENDPOINT + "api/ConsumerMessages/GetMessagesByLoanId?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpsertMessage(request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerMessages/UpsertMessage", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetTasksByLoanId(loanId, token) {
    return axios.get(API_ENDPOINT + "api/ConsumerTasks/GetTasksByLoanId?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpsertTask(request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerTasks/UpsertTask", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  DeleteTaskById(taskId, loanId, token) {
    return axios.post(API_ENDPOINT + `api/ConsumerTasks/DeleteTaskById?taskId=${taskId}&loanId=${loanId}`, {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  CreateManualBorrowerTaskNotifications(loanId, request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerTasks/CreateManualBorrowerTaskNotifications?loanId=" + loanId, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetDocumentsByLoanId(loanId, token) {
    return axios.get(API_ENDPOINT + "api/ConsumerDocuments/GetDocumentsByLoanId?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UploadAttachmentsToLoan(request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerDocuments/UploadAttachmentsToLoan", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetDocumentByAttachmentId(attachmentId, token) {
    return axios.get(API_ENDPOINT + "api/ConsumerDocuments/GetDocumentByAttachmentId?attachmentId=" + attachmentId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  UpsertDocuments(request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerDocuments/UpsertDocuments", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetDisclosureTrackingLog(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetDisclosureTrackingLog?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetContactsLATFromLoan(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetContactsLATFromLoan?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetSurveyByLoanId(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetSurveyByLoanId?loanId=" + loanId,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetDocuSign(id, base64Pdf, status, documentName, signers, token, loanOfficerName, isEmbeddedSign = false, taskTitle = null, loanOfficerEmail = null) {
    return axios.post(WEBAPIV2_ENDPOINT + "api/DocuSign/SendEnvelope",
      {
        Id: id,
        DocumentBase64: base64Pdf,
        Status: status,
        DocumentName: documentName,
        Signers: signers,
        LoanOfficerName: loanOfficerName,
        LoanOfficerEmail: loanOfficerEmail,
        isEmbeddedSign: isEmbeddedSign,
        TaskTitle: taskTitle
      },
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      });
  },
  GetEnvelope(envelopeId, token) {
    return axios.get(WEBAPIV2_ENDPOINT + "api/DocuSign/GetEnvelope/" + envelopeId, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  MarkMessagesRead(azureId, loanId, token) {
    return axios.post(WEBAPIV2_ENDPOINT + `api/LoanLaunchMessages/MarkMessagesRead?azureId=${azureId}&loanId=${loanId}`, null, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  },
  GetEnvelopeDocument(envelopeId, token) {
    return axios.get(WEBAPIV2_ENDPOINT + "api/DocuSign/GetEnvelopeDocument/" + envelopeId, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  ResendEnvelope(envelopeId, token) {
    return axios.post(WEBAPIV2_ENDPOINT + `api/DocuSign/ResendEnvelope/${envelopeId}`, {}, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetPostCloseConditions(loanGuid, token) {
    //return axios.get('https://localhost:44346/' + `api/SwiftAppAI/GetPostCloseConditions?loanGuid=${loanGuid}`, {
    return axios.get(WEBAPIV2_ENDPOINT + `api/SwiftAppAI/GetPostCloseConditions?loanGuid=${loanGuid}`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  SavePostCloseConds(loanGuid, conditionList, token) {
    //return axios.post('https://localhost:44346/' + `api/SwiftAppAI/SavePostCloseConds?loanGuid=${loanGuid}`, conditionList, {
    return axios.post(WEBAPIV2_ENDPOINT + `api/SwiftAppAI/SavePostCloseConds?loanGuid=${loanGuid}`, conditionList, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  UpdatePostCloseCondition(condition, token) {
    //return axios.post('https://localhost:44346/' + `api/SwiftAppAI/UpdatePostCloseCondition`, condition, {
    return axios.post(WEBAPIV2_ENDPOINT + `api/SwiftAppAI/UpdatePostCloseCondition`, condition, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetConditionNotes(loanGuid, conditionGuid, token) {
    //return axios.get('https://localhost:44346/' + `api/SwiftAppAI/GetConditionNotes?loanGuid=${loanGuid}&conditionGuid=${conditionGuid}`, {
    return axios.get(WEBAPIV2_ENDPOINT + `api/SwiftAppAI/GetConditionNotes?loanGuid=${loanGuid}&conditionGuid=${conditionGuid}`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  SaveConditionNote(newConditionNote, token) {
    //return axios.post('https://localhost:44346/' + `api/SwiftAppAI/SaveConditionNote`, newConditionNote, {
    return axios.post(WEBAPIV2_ENDPOINT + `api/SwiftAppAI/SaveConditionNote`, newConditionNote, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetInternalTasks(params, token) {
    const queryString = new URLSearchParams(params).toString();
    return axios.get(`${API_ENDPOINT}api/InternalTasks/GetInternalAssignedTasksByFields?${queryString}`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetInternalTaskTemplates(params, token) {
    const queryString = new URLSearchParams(params).toString();
    return axios.get(`${API_ENDPOINT}api/InternalTasks/GetInternalTaskTemplates?${queryString}`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  UpsertInternalTaskTemplate(data, token) {
    return axios.post(`${API_ENDPOINT}api/InternalTasks/UpsertInternalTaskTemplate`, data, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  UpsertInternalAssignedTask(params, token) {
    /*const queryString = new URLSearchParams(params).toString();*/
    return axios.post(`${API_ENDPOINT}api/InternalTasks/UpsertInternalAssignedTask`,
    {
      id: params.id,
      archived: params.archived,
      important: params.important.toString(),
      completed: params.completed,
      status: params.status,
      lastUpdated: params.lastUpdated,
      initialEmailSent: params.initialEmailSent.toString(),
      title: params.title,
      assignedTo: params.assignedTo,
      notes: params.notes,
      followUpDate: params.followUpDate,
      azureId: params.azureId,
      createdBy: params.createdBy,
      loanId: params.loanId,
      templateId: params.templateId,
      created: params.created,
      followUpSent: params.followUpSent,
      teamIds: params.teamIds,
      orgId: params.orgId,
      noteEmailSent: params.noteEmailSent?.toString(),
    },
    {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  UpsertInternalTaskTemplate(params, token) {
    const queryString = new URLSearchParams(params).toString();
    return axios.post(`${API_ENDPOINT}api/InternalTasks/UpsertInternalTaskTemplate?${queryString}`, {}, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  TriggerLoanFlowTasks(loanId, token) {
    return axios.post(`${WEBAPIV2_ENDPOINT}api/Console/LoanFlowTasks?loanId=${loanId}`, {}, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetInternalTaskTeams(token) {
    return axios.get(`${WEBAPIV2_ENDPOINT}api/InternalTask/GetInternalTaskTeams`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetAzureUsers(token) {
    return axios.get(`${WEBAPIV2_ENDPOINT}api/Servicing/GetAzureUsers?activeOnly=true`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  GetLoanByLoanNumberAuthorized(azureId, loanNumber, token) {
    return axios.get(`${WEBAPIV2_ENDPOINT}api/Contacts/GetLoanByLoanNumberAuthorized?azureId=${azureId}&loanNumber=${loanNumber}`,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    );
  },
  GetContactByLoanIdWithDetails(loanId, token) {
    return axios.get(`${WEBAPIV2_ENDPOINT}api/Contacts/GetContactByLoanIdWithDetails?loanId=${loanId}`,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    );
  },
  GetMilestoneFreeRoles(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Loans/GetMilestoneFreeRoles?loanId=" + loanId, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  },
  UpdateMilestoneFreeRoles(loanId, milestoneLogId, userId, token) {
    return axios.put(API_ENDPOINT + "api/Loans/UpdateMilestoneFreeRole?loanId=" + loanId + "&milestoneLogId=" + milestoneLogId, JSON.stringify(userId),
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      });
  },
  ClearTaskNotes(id, token) {
    return axios.post(`${API_ENDPOINT}api/InternalTasks/ClearTaskNotes?id=${id}`, '', {
      headers: {
        "Authorization": "Bearer " + token,
        "accept": "text/plain"
      }
    });
  },
  GetBorrowerTaskTemplates(request, token) {
    const queryString = new URLSearchParams(request).toString();

    return axios.get(`${API_ENDPOINT}api/ConsumerTasks/GetBorrowerTaskTemplates?${queryString}`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"

      }
    });
  },
  UpsertBorrowerTaskTemplate(request, token) {

    return axios.post(`${API_ENDPOINT}api/ConsumerTasks/UpsertBorrowerTaskTemplate`, request, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"

      }
    });
  },
  async GetRoles(azureId, token) {
    return axios.get(WEBAPIV2_ENDPOINT + `api/Roles/GetUserRoles?Id=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  DeleteBorrowerTaskTemplate(request, token) {

    return axios.post(`${API_ENDPOINT}api/ConsumerTasks/DeleteBorrowerTaskTemplate?id=${request}`, {}, {
      headers: {
        "Authorization": "Bearer " + token,

      }
    });
  },
  GetPlanCodes(token) {

    return axios.get(`${API_ENDPOINT}api/Loans/GetPlanCodes`, {
      headers: {
        "Authorization": "Bearer " + token,

      }
    });
  },
  SetPlanCode(token, planCodeId, loanId) {
    return axios.post(`${API_ENDPOINT}api/Loans/SetPlanCode/${planCodeId}/${loanId}`, {}, {
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    });
  },
  ArchiveLoan(request, token) {
    return axios.post(API_ENDPOINT + "api/Loans/ArchiveLoan", request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  GetAttachmentAISummary(attachmentId, token) {
    return axios.get(
      API_ENDPOINT + `api/ai/summary/${attachmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  GetAttachmentAISummariesBatch(attachmentIds, token) {
    return axios.post(
      API_ENDPOINT + `api/ai/summaries/batch`,
      { attachmentIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  RegenerateDocumentSummary(loanId, attachmentId, accessToken) {
    return axios.post(
      GSAI_API + `api/OpenWebUI/RegenerateDocumentSummary?loanId=${encodeURIComponent(loanId)}&attachmentId=${encodeURIComponent(attachmentId)}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'API-Key': API_KEY
        }
      }
    );
  },
  SendDocumentChatMessage(loanId, attachmentId, message, accessToken) {
    const formData = new FormData();
    formData.append('loanId', loanId);
    formData.append('attachmentId', attachmentId);
    formData.append('message', message);

    return fetch(GSAI_API + 'api/OpenWebUI/SendDocumentChatMessage', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'API-Key': API_KEY
      },
      body: formData
    });
  },
  GetLoanAlerts(loanId, token) {
    return axios.get(
      GSAI_API + `api/Alerts/GetLoanAlerts?loanId=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY
        }
      }
    );
  },
  GetAlertCount(loanId, token) {
    return axios.get(
      GSAI_API + `api/Alerts/GetAlertCount?loanId=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY
        }
      }
    );
  },
  AcknowledgeAlert(alertId, loanId, token) {
    return axios.post(
      GSAI_API + `api/Alerts/AcknowledgeAlert?alertId=${encodeURIComponent(alertId)}&loanId=${encodeURIComponent(loanId)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY
        }
      }
    );
  },
  DismissAlert(alertId, loanId, token) {
    return axios.post(
      GSAI_API + `api/Alerts/DismissAlert?alertId=${encodeURIComponent(alertId)}&loanId=${encodeURIComponent(loanId)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY
        }
      }
    );
  },
  UndismissAlert(alertId, loanId, token) {
    return axios.post(
      GSAI_API + `api/Alerts/UndismissAlert?alertId=${encodeURIComponent(alertId)}&loanId=${encodeURIComponent(loanId)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY
        }
      }
    );
  },
  CreateAIAlert(loanId, alertData, token) {
    return axios.post(
      GSAI_API + `api/Alerts/CreateAlert?loanId=${encodeURIComponent(loanId)}`,
      alertData,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "API-Key": API_KEY,
          "Content-Type": "application/json"
        }
      }
    );
  },
  GetIncomingTwilioMessages(phoneNumber, token) {
    return axios.get(API_ENDPOINT + "api/ConsumerPortal/GetIncomingTwilioMessages?phoneNumber=" + phoneNumber, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  },
  MergePDFs(files, accessToken) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file.rawFile));
    return axios.post(API_ENDPOINT + "api/ConsumerDocuments/MergeMultiplePDF", formData, {
      headers: {
        'Authorization': "Bearer " + accessToken
      }
    })
  },
  CheckSigningTasks(request, token) {
    return axios.post(API_ENDPOINT + "api/ConsumerTasks/CheckSigningTasks", request,
    {
        headers: {
          "Authorization": "Bearer " + token
        }
    });
  },
  RequestFNMA34Duplicate(request, accessToken) {
    return axios.post("https://gsappsvc.goldstarfinancial.com/api/FNMARequest", request, {
      headers: {
        'Authorization': 'Basic am5ld3RvbkBnc2ZtYWlsLmNvbToyIUBYemRka2MwMDc=',
        'Content-Type': 'application/json',
        'cache-control': 'no-cache'
      }
    });
  },
  GetKeyFieldsForDuplication(loanId, accessToken) {
    return axios.get(WEBAPIV2_ENDPOINT + "api/FNMA34/GetKeyFields?loanId=" + loanId, {
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    });
  },
  RequestFNMA34DuplicationEnhanced(request, accessToken) {
    return axios.post(WEBAPIV2_ENDPOINT + "api/FNMA34/RequestDuplication", request, {
      headers: {
        "Authorization": "Bearer " + accessToken,
        "Content-Type": "application/json"
      }
    });
  },
  GetDuplicationStatus(requestId, accessToken) {
    return axios.get(WEBAPIV2_ENDPOINT + "api/FNMA34/GetDuplicationStatus?requestId=" + requestId, {
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    });
  },
  UpsertRecentLoan(azureId, loan, accessToken) {
    return axios.post(
      API_ENDPOINT + "api/Conditions/UpsertRecentLoan?azureId=" + azureId,
      loan,
      {
        headers: {
          "Authorization": "Bearer " + accessToken
        }
      }
    );
  },
  GetBorrowerPreferredName(loanId, token) {
    return axios.get(API_ENDPOINT + "api/Applications/GetBorrowerPreferredName?loanId=" + loanId, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  }

};
